import _classCallCheck from "/app/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/app/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "/app/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _createSuper from "/app/node_modules/@babel/runtime/helpers/esm/createSuper.js";
import React__default from 'react';
var VisualElementHandler = /*#__PURE__*/function (_React__default$Compo) {
  _inherits(VisualElementHandler, _React__default$Compo);
  var _super = _createSuper(VisualElementHandler);
  function VisualElementHandler() {
    _classCallCheck(this, VisualElementHandler);
    return _super.apply(this, arguments);
  }
  _createClass(VisualElementHandler, [{
    key: "getSnapshotBeforeUpdate",
    value:
    /**
     * Update visual element props as soon as we know this update is going to be commited.
     */
    function getSnapshotBeforeUpdate() {
      var _this$props = this.props,
        visualElement = _this$props.visualElement,
        props = _this$props.props;
      if (visualElement) visualElement.setProps(props);
      return null;
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {}
  }, {
    key: "render",
    value: function render() {
      return this.props.children;
    }
  }]);
  return VisualElementHandler;
}(React__default.Component);
export { VisualElementHandler };